import {
    createAction,
    createSlice,
    type PayloadAction,
} from '@reduxjs/toolkit';

import type { RootState } from '../root/config.store';
import { type CustomerInfo, initialState } from '../../types/customerInfo';

// slice
export const customerInfoSlice = createSlice({
    name: 'customerInfo',
    initialState,
    reducers: {
        fetchAllisLoading(state) {
            state.loading = true;
        },
        fetchAllSucceeded(state, action: PayloadAction<CustomerInfo[]>) {
            state.data = action.payload;
            state.loading = false;
        },
        fetchAllFailure(state, action: PayloadAction<string>) {
            state.error = action.payload;
            state.loading = false;
        },
    },
});

// Actions
export const customerInfoActions = {
    fetchAll: createAction(`${customerInfoSlice.name}`),
    fetchAllisLoading: customerInfoSlice.actions.fetchAllisLoading,
    fetchAllSucceeded: customerInfoSlice.actions.fetchAllSucceeded,
    fetchAllFailure: customerInfoSlice.actions.fetchAllFailure,
};

// Selectors
export const selectCustomerInfo = (state: RootState): CustomerInfo[] => state.customerInfo.data;

// Reducer
export default customerInfoSlice.reducer;